export default {
  List: {
    Title: "Điều chuyển",
    Location: "Điều chuyển vị trí tài sản",
    User: "Điều chuyển đối tượng sử dụng",
    Management: "Điều chuyển đơn vị quản lý",
  },
  Location: {
    Search: "Tìm kiếm biên bản điều chuyển",
    WarningDelete:
      "<Mã Tài sản> - Tên tài sản đã phát sinh ngày <ngày phát sinh nghiệp vụ gần nhất>. Vui lòng xóa phát sinh ngày <ngày phát sinh nghiệp vụ gần nhất> trước khi xóa biên bản điều chuyển.",
    ExportLocation: "Danh sách điều chuyển vị trí tài sản",
  },
  User: {
    Search: "Tìm kiếm biên bản điều chuyển",
    ExportUser: "Danh sách điều chuyển đối tượng sử dụng",
  },
  Management: {
    Transfering: "Đang điều chuyển",
    Received: "Đã nhận tài sản",
    Cancelled: "Từ chối",
    Search: "Tìm kiếm biên bản điều chuyển",
    ExportManagement: "Danh sách điều chuyển đơn vị quản lý",
    ErrorAccept: "Chỉ người quản lý nơi điều chuyển đến mới được nhận tài sản!",
    ErrorAcceptOrDeny: "Chỉ được phép thực hiện với biên bản có trạng thái đang thực hiện.",
    ErrorDeny: "Chỉ người quản lý nơi điều chuyển đến mới được từ chối tài sản!",
    ErrorDeleteTransfer: "Chỉ người lập biên bản mới có quyền xóa!",
    ErrorEditTransfer: "Bạn không có quyền thực hiện chức năng này!",
  },
  DenyDetail: {
    DenyTitle: "Từ chối",
    DenyDate: "Ngày từ chối",
    Reason: "Lý do từ chối",
    Deny: "Từ chối",
    ErrorTransferDate: "Ngày từ chối không được nhỏ hơn ngày lập biên bản điều chuyển",
  },
  AcceptDetail: {
    AcceptTitle: "Nhận tài sản",
    Manager: "Người quản lý",
    Accept: "Nhận tài sản",
    Location: "Vị trí tài sản",
  },
  Common: {
    TransferDate: "Điều chuyển ngày",
    DateTransfer: "Ngày điều chuyển",
    TransferInfo: "Thông tin điều chuyển",
    Confirm: "Nhận tài sản",
    Deny: "Từ chối",
    FromOrganizationUnit: "Từ đơn vị",
    Deliver: "Người giao",
    Reason: "Lý do điều chuyển",
    Status: "Trạng thái",
    ToOrganizationUnit: "Đến đơn vị",
    Receiver: "Người nhận",
    LicenseInfo: "Thông tin chứng từ",
    AssetTallyNo: "Số biên bản",
    AssetTransfer: "Tài sản điều chuyển",
    Cancel: "Từ chối nhận tài sản",
    Add: "Nhận tài sản",
    Close: "Đóng",
    Edit: "Sửa",
    CancelAsset: "Hủy tài sản",
    Delete: "Xóa biên bản",
    DeleteWarning: "Chỉ được phép xóa biên bản có trạng thái Đang thực hiện",
  },
};
